export default __webpack_public_path__ + "static/towers-ba89b377040c8c6795d4efe6308b659b.jpg";